var ndp2iiifIP = window.configuration.ndp2iiif_IP
var ndp2iiifUrl = window.configuration.ndp2iiif_url
var ndp2iiifLogin = window.configuration.ndp2iiif_login
var ndp2iiifPassword = window.configuration.ndp2iiif_password
var backendUrl = window.configuration.backend_url
var openLayersAnimateDuration = window.configuration.open_layers_animate_duration
export { ndp2iiifIP, ndp2iiifUrl, ndp2iiifLogin, ndp2iiifPassword, backendUrl, openLayersAnimateDuration }
